var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFeedback = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 48,
    viewBox: "0 0 56 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7354 0V14.65H38.3585V28.7347H43.0815L47.542 32.241L48.0559 28.7347H56.0001V0H18.7354Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7354 0V14.65H38.3585V28.7347H43.0815L47.542 32.241L48.0559 28.7347H56.0001V0H18.7354Z",
    fill: "#013BAE",
    fillOpacity: 0.18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3585 13.5563H1.09375C0.489672 13.5563 0 14.0459 0 14.65V43.3847C0 43.9888 0.489672 44.4784 1.09375 44.4784H8.09277L8.46978 47.0496C8.52633 47.4356 8.78434 47.7623 9.1467 47.9069C9.27773 47.9592 9.41511 47.9847 9.55172 47.9847C9.79311 47.9847 10.032 47.9048 10.2279 47.7508L14.3908 44.4784H38.3585C38.9625 44.4784 39.4522 43.9888 39.4522 43.3847V14.65C39.4522 14.0459 38.9625 13.5563 38.3585 13.5563ZM37.2647 42.2909H14.0124C13.7673 42.2909 13.5291 42.3733 13.3364 42.5248L10.3603 44.8643L10.1201 43.226C10.0414 42.689 9.5807 42.2909 9.03798 42.2909H2.1875V15.7438H37.2647V42.2909Z",
    fill: "#0D223E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74023 25.6262H30.7118C31.3159 25.6262 31.8056 25.1365 31.8056 24.5324C31.8056 23.9283 31.3159 23.4387 30.7118 23.4387H8.74023C8.13616 23.4387 7.64648 23.9283 7.64648 24.5324C7.64648 25.1365 8.13616 25.6262 8.74023 25.6262Z",
    fill: "#0D223E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74023 35.1188H30.7118C31.3159 35.1188 31.8056 34.6291 31.8056 34.025C31.8056 33.4209 31.3159 32.9313 30.7118 32.9313H8.74023C8.13616 32.9313 7.64648 33.4209 7.64648 34.025C7.64648 34.6291 8.13616 35.1188 8.74023 35.1188Z",
    fill: "#0D223E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74023 30.3725H11.9987C12.6028 30.3725 13.0925 29.8828 13.0925 29.2787C13.0925 28.6747 12.6028 28.185 11.9987 28.185H8.74023C8.13616 28.185 7.64648 28.6747 7.64648 29.2787C7.64648 29.8828 8.13616 30.3725 8.74023 30.3725Z",
    fill: "#0D223E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7119 28.185H17.4917C16.8876 28.185 16.3979 28.6747 16.3979 29.2787C16.3979 29.8828 16.8876 30.3725 17.4917 30.3725H30.712C31.316 30.3725 31.8057 29.8828 31.8057 29.2787C31.8057 28.6747 31.3159 28.185 30.7119 28.185Z",
    fill: "#0D223E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFeedback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconFeedback.ca9fc3a342195a6c805a3ba1706826b8.svg";